import { CURRENT_USERNAME } from "./login";
import { beginLoading, endLoading } from "./loadingSpinner";
import { clearMessages, createBackendErrorMessages, createErrorMessages, createSuccessMessages, messagesReceived } from "./message";

import { TYPE_KEY } from "../common/constant";
import navigate from "../common/navigate";
import rest from "../common/rest";
import ObjectUtils, { coalesce } from "../utils/ObjectUtils";
import SurveyUtils from "./../utils/SurveyUtils";
import { getActivationHistory } from "../utils/TemplateActivationUtils";
import { setPropertyValue } from "./fundingArea";
import { resetSurvey } from "./survey";
import { resetSurvey as resetSurveyEditor } from "./surveyEditor";
import { resetSurveyView } from "./surveyView";

const { getDeepProperty } = ObjectUtils;

const LOAD_ACTION = "TEMPLATES.LOAD_ACTION";
const UPDATE_TEMPLATE_ACTION = "TEMPLATES.UPDATE_TEMPLATE_ACTION";

export const templateUpdated = (template) => ({ type: UPDATE_TEMPLATE_ACTION, template });
const LOAD_HISTORY_ACTION = "TEMPLATES.LOAD_HISTORY_ACTION";

const HISTORY_INDEX = "TEMPLATES.HISTORY_INDEX";
const SHOW_HIDE_HISTORY_ACTION = "TEMPLATES.SHOW_HIDE_HISTORY_ACTION";
const SORT_COLUMN_ACTION = "TEMPLATES.SORT_COLUMN_ACTION";
const ACTIVATE_TEMPLATE = "TEMPLATES.ACTIVATE";
const SHOW_ACTIVATION_INFO = "TEMPLATES.SHOW_ACTIVATION_INFO";
const CLOSE_ACTIVATE_TEMPLATE_DIALOG = "TEMPLATES.CLOSE_ACTIVATE_DIALOG";
const SYNC_TEMPLATE = "TEMPLATES.SYNC";
const CLOSE_SYNC_TEMPLATE_DIALOG = "TEMPLATES.CLOSE_SYNC_DIALOG";
const CLOSE_ACTIVATION_INFO = "TEMPLATES.CLOSE_ACTIVATION_INFO_DIALOG";

export const TEMPLATE_LIST = "templateList";
export const LOADED = "loaded";
export const TEMPLATE_HISTORY = "templateHistory";
export const ACTIVATION_HISTORY = "activationHistory";
export const SHOW_HISTORY = "showHistory";
export const SORT_TABLE_TEMPLATE = "sortTableTemplate";
export const SORT_TABLE_TEMPLATE_BY = "sortTableTemplateBy";
export const SORT_TABLE_TEMPLATE_ASCENDING = "sortTableTemplateAscending";
export const SHOW_ACTIVATION_DIALOG = "showActivationDialog";
export const SHOW_ACTIVATION_INFO_DIALOG = "showActivationInfoDialog";
export const SHOW_SYNC_DIALOG = "showSyncDialog";
export const TEMPLATE_FOR_ACTIVATION = "templateForActivation";

const emptyHistory = {
  [TEMPLATE_HISTORY]: [],
  [SHOW_HISTORY]: []
};

const initialState = {
  [TEMPLATE_LIST]: [],
  [TEMPLATE_HISTORY]: [],
  [SHOW_HISTORY]: [],
  [SORT_TABLE_TEMPLATE]: false,
  [SORT_TABLE_TEMPLATE_ASCENDING]: true,
  [SORT_TABLE_TEMPLATE_BY]: "",
  [SHOW_ACTIVATION_DIALOG]: false,
  [SHOW_ACTIVATION_INFO_DIALOG]: false,
  [TEMPLATE_FOR_ACTIVATION]: null
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case LOAD_ACTION: {
      let sortedTemplateList = SurveyUtils.handleSortTemplateList(action[TEMPLATE_LIST], "lastModifiedDate");
      newState = Object.assign({}, state, {
        [TEMPLATE_LIST]: sortedTemplateList,
        [SORT_TABLE_TEMPLATE_BY]: "",
        [SORT_TABLE_TEMPLATE]: false
      });
      newState = Object.assign({}, newState, emptyHistory);
      break;
    }
    case SHOW_HIDE_HISTORY_ACTION: {
      let idx = action[HISTORY_INDEX];
      let update = { [SHOW_HISTORY]: [] };
      //if we decide to show multiple history we will refactore this code;
      update[SHOW_HISTORY][idx] = action[SHOW_HISTORY];
      newState = Object.assign({}, state, update);
      break;
    }
    case LOAD_HISTORY_ACTION: {
      let idx = action[HISTORY_INDEX];
      let update = { [TEMPLATE_HISTORY]: [] };
      //if we deside to show multiple history we will refactore this code;
      update[TEMPLATE_HISTORY][idx] = action[TEMPLATE_HISTORY];
      newState = Object.assign({}, state, update);
      break;
    }
    case UPDATE_TEMPLATE_ACTION:
      newState = { ...state, [TEMPLATE_LIST]: state[TEMPLATE_LIST].map((template) =>
        template.identifier === action.template.identifier ? action.template : template) };
      break;
    case SORT_COLUMN_ACTION: {
      let sortedTemplateList = SurveyUtils.handleSortTemplateList(
        state[TEMPLATE_LIST],
        action[SORT_TABLE_TEMPLATE_BY],
        action[SORT_TABLE_TEMPLATE_ASCENDING]
      );
      newState = Object.assign({}, state, {
        [TEMPLATE_LIST]: sortedTemplateList,
        [SORT_TABLE_TEMPLATE]: true,
        [SORT_TABLE_TEMPLATE_BY]: action[SORT_TABLE_TEMPLATE_BY],
        [SORT_TABLE_TEMPLATE_ASCENDING]: action[SORT_TABLE_TEMPLATE_ASCENDING]
      });
      break;
    }
    case ACTIVATE_TEMPLATE: {
      newState = Object.assign({}, state, {
        [TEMPLATE_FOR_ACTIVATION]: action[TEMPLATE_FOR_ACTIVATION],
        [SHOW_ACTIVATION_DIALOG]: true
      });
      break;
    }
    case SYNC_TEMPLATE: {
      newState = Object.assign({}, state, {
        [TEMPLATE_FOR_ACTIVATION]: action[TEMPLATE_FOR_ACTIVATION],
        [SHOW_SYNC_DIALOG]: true
      });
      break;
    }
    case SHOW_ACTIVATION_INFO: {
      newState = Object.assign({}, state, {
        [ACTIVATION_HISTORY]: action[ACTIVATION_HISTORY],
        [TEMPLATE_FOR_ACTIVATION]: action[TEMPLATE_FOR_ACTIVATION],
        [SHOW_ACTIVATION_INFO_DIALOG]: true
      });
      break;
    }
    case CLOSE_ACTIVATE_TEMPLATE_DIALOG: {
      newState = Object.assign({}, state, {
        [TEMPLATE_FOR_ACTIVATION]: null,
        [SHOW_ACTIVATION_DIALOG]: false
      });
      break;
    }
    case CLOSE_SYNC_TEMPLATE_DIALOG: {
      newState = Object.assign({}, state, {
        [TEMPLATE_FOR_ACTIVATION]: null,
        [SHOW_SYNC_DIALOG]: false
      });
      break;
    }
    case CLOSE_ACTIVATION_INFO: {
      newState = Object.assign({}, state, {
        [TEMPLATE_FOR_ACTIVATION]: null,
        [SHOW_ACTIVATION_INFO_DIALOG]: false
      });
      break;
    }
    default:
      newState = Object.assign({}, state, {});
      break;
  }
  return newState;
}

export function loadTemplateListFilter() {
  let surveyFilterLink = "/admin/admin/surveys/";

  return (dispatch, getState) => {
    dispatch(beginLoading());
    dispatch(resetSurveyView());
    dispatch(resetSurveyEditor());
    dispatch(resetSurvey());
    let fundingAreaId = getDeepProperty(getState(), "fundingArea", "selectedFundingArea", "templates", "id");
    let programId = getDeepProperty(getState(), "fundingArea", "selectedProgram", "templates", "id");
    let programInstanceId = getDeepProperty(getState(), "fundingArea", "selectedProgramInstance", "templates", "id");

    if (fundingAreaId || programId || programInstanceId) {
      surveyFilterLink = surveyFilterLink + "?";
    }

    if (fundingAreaId) {
      surveyFilterLink = surveyFilterLink + "fundingAreaId=" + fundingAreaId + "&";
    }
    if (programId) {
      surveyFilterLink = surveyFilterLink + "programId=" + programId + "&";
    }
    if (programInstanceId) {
      surveyFilterLink = surveyFilterLink + "programInstanceId=" + programInstanceId + "&";
    }

    rest.doGet(surveyFilterLink).then(
      (json) => {
        if (json.surveys) {
          dispatch(loadSuccessful(json.surveys));
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

/**
 * Function makes an asynchronious rest.delete call
 */
export function deleteTemplate(template, link) {
  return (dispatch) => {
    dispatch(beginLoading());
    rest.doDelete(`${link}/${template.identifier}`, template.identifier).then(
      (json) => {
        if (json) {
          dispatch(loadTemplateListFilter());
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

/**
 * Function makes an asynchronious rest.delete call
 */
export function deleteTemplateVersion(template, link) {
  return (dispatch) => {
    rest.doDelete(`${link}/${template.survey.identifier}/version/${template.history.version}`).then(
      (json) => {
        if (json) {
          dispatch(loadTemplateListFilter(link));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

/**
 * Function makes an asynchronious rest.get call, and try to load template list from the server.
 */
export function loadHistory(i, survey, showHistory) {
  let identifier = coalesce(
    ObjectUtils.getDeepProperty(survey, "identifier"),
    ObjectUtils.getDeepProperty(survey, "surveyId")
  );
  return (dispatch, getState) => {
    dispatch(beginLoading());
    let show = !getState().templatelist.showHistory[identifier];
    if (showHistory) {
      dispatch(showHideHistory(identifier, show));
    }
    
    if (show) {
      rest.doGet(`/admin/admin/surveys/history/${identifier}`).then(
        (json) => {
          if (json.historyList) {
            dispatch(loadHistorySuccessful(identifier, json.historyList));
            dispatch(endLoading());
          } else {
            dispatch(messagesReceived(createErrorMessages(json)));
            dispatch(endLoading());
          }
        },
        (reason) => {
          dispatch(messagesReceived(createBackendErrorMessages(reason)));
          dispatch(endLoading());
        }
      );
    } else {
      dispatch(endLoading());
    }
  };
}

/**
 * Load successful action
 */
export function loadSuccessful(list) {
  return {
    [TYPE_KEY]: LOAD_ACTION,
    [TEMPLATE_LIST]: list
  };
}

/**
 * Load successful action
 */
export function loadHistorySuccessful(identifier, list) {
  return {
    [TYPE_KEY]: LOAD_HISTORY_ACTION,
    [HISTORY_INDEX]: identifier,
    [TEMPLATE_HISTORY]: list
  };
}

const showHideHistory = (identifier, show) => {
  return {
    [TYPE_KEY]: SHOW_HIDE_HISTORY_ACTION,
    [HISTORY_INDEX]: identifier,
    [SHOW_HISTORY]: show
  };
};

export const sortColumn = (columnType, acs) => {
  return {
    [TYPE_KEY]: SORT_COLUMN_ACTION,
    [SORT_TABLE_TEMPLATE_BY]: columnType,
    [SORT_TABLE_TEMPLATE]: true,
    [SORT_TABLE_TEMPLATE_ASCENDING]: acs
  };
};

export function publishSurvey(survey) {
  return (dispatch) => {
    rest
      .doGet(
        //survey._links.self[1].href //it didn't work because the deploy was bad.
        `/admin/admin/surveys/${survey.identifier}/publish`
      )
      .then(
        (json) => {
          if (json.statusText === "OK") {
            navigate.to("/userArea/respondentsOverview");
          } else {
            dispatch(messagesReceived(createErrorMessages(json)));
          }
        },
        (reason) => {
          dispatch(messagesReceived(createBackendErrorMessages(reason)));
        }
      );
  };
}

export const activateTemplate = (template) => {
  return (dispatch) => {
    dispatch(clearMessages());

    dispatch(setPropertyValue("selectedFundingArea", "templateActivation", template.fundingArea));
    dispatch(setPropertyValue("selectedProgram", "templateActivation", template.program));
    dispatch(setPropertyValue("selectedProgramInstance", "templateActivation", template.programInstance));

    dispatch({
      [TYPE_KEY]: ACTIVATE_TEMPLATE,
      [TEMPLATE_FOR_ACTIVATION]: template
    });
  };
};

export const questionSync = (template) => {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: SYNC_TEMPLATE,
      [TEMPLATE_FOR_ACTIVATION]: template
    });
  };
};

export const syncQuestions = (template) => {
  return (dispatch) => {
    rest.doGet(`/admin/sync/questions/${template.identifier}/version/${template.version}`).then(
      (json) => {
        if (json.isSynched) {
          dispatch(closeQuestionSyncDialog());
          dispatch(loadTemplateListFilter());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
};

export const showActivationInfoDialog = (template) => {
  return async (dispatch) => {
    dispatch(beginLoading());
    try {
      const identifier = template.identifier ?? template.surveyId;
      const isSemester = SurveyUtils.isSemesterTypeProgram(template.program?.name);
      const [history, activations] = await Promise.all([
        rest.doGet(`/admin/admin/surveys/history/${identifier}`),
        isSemester ? Promise.resolve(null) : rest.doGet(`/survey/publishing/activations?surveyId=${encodeURIComponent(identifier)}`)
      ]);
      dispatch({
        [TYPE_KEY]: SHOW_ACTIVATION_INFO,
        [TEMPLATE_FOR_ACTIVATION]: template,
        [ACTIVATION_HISTORY]: getActivationHistory(history.historyList ?? [], activations)
      });
    } catch (reason) {
      dispatch(messagesReceived(createBackendErrorMessages(reason)));
    } finally {
      dispatch(endLoading());
    }
  };
};

export const closeTemplateActivationDialog = () => {
  return {
    [TYPE_KEY]: CLOSE_ACTIVATE_TEMPLATE_DIALOG
  };
};

export const closeQuestionSyncDialog = () => {
  return {
    [TYPE_KEY]: CLOSE_SYNC_TEMPLATE_DIALOG
  };
};

export const closeActivationInfoDialog = () => {
  return {
    [TYPE_KEY]: CLOSE_ACTIVATION_INFO
  };
};

export const synchronizeTemplateVersion = (template, history) => async (dispatch, getState) => {
  if (getState().login[CURRENT_USERNAME] !== "daad-support@mainlevel.de" || history.status !== "active") {
    return;
  }
  dispatch(clearMessages());
  try {
    const result = await rest.doPost(
      `/admin/publish/survey/synchronize/${encodeURIComponent(template.identifier)}/version/${encodeURIComponent(history.version)}`
    );
    if (result && result.isPublished === true) {
      dispatch(messagesReceived(createSuccessMessages("templateList.synchronize.success")));
    } else {
      const message = result && result.hasDuplicatedKeys
        ? "templateList.synchronize.duplicateKeys"
        : "templateList.synchronize.failed";
      dispatch(messagesReceived(createErrorMessages(message)));
    }
  } catch (reason) {
    dispatch(messagesReceived(createBackendErrorMessages(reason)));
  }
};